import tr from './languages/tr.json';
import en from './languages/en.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
    // 'tr-TR': tr,
    // 'tr':tr,
    'en-EN': en
}

const detectionLang = {
    // order and from where user language should be detected
    order: ['localStorage', 'navigator', 'path'],

    // keys or params to lookup language from
    lookupLocalStorage: 'language',

    // cache user language on
    caches: ['localStorage']
}

i18n.use(initReactI18next).init({
    resources,
    fallbackLng: 'en-EN',
    lng: "en",
    // detection: detectionLang,
    interpolation: {
        escapeValue: false
    }
});

export default i18n;